import { Box, Fade, Modal, Backdrop } from "@mui/material";
import React from "react";
import "./modalwrap.scss";

const ModalWrap = ({ open, onClose, children, className }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 200,
        },
      }}
      className="modal-wrapper"
    >
      <Fade in={open}>
        <Box className={className + " modal-box"}>{children}</Box>
      </Fade>
    </Modal>
  );
};

export default ModalWrap;
